(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpx-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tpx-product-hero')) {
    customElements.define('tpx-product-hero', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-go-to]')];
        this.names = [...this.querySelectorAll('[data-product-name]')];
        this.cta = this.querySelector('[data-hero-cta]');
        this.index = 0;
        this.timer = null;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.handleVisibility = () => document.hidden ? this.stop() : this.start();
        this.handleMotionPreference = () => this.reduceMotion.matches ? this.stop() : this.start();

        this.dots.forEach((dot) => dot.addEventListener('click', () => {
          this.show(Number(dot.dataset.goTo));
          this.restart();
        }));
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.start();
        });
        document.addEventListener('visibilitychange', this.handleVisibility);
        this.reduceMotion.addEventListener('change', this.handleMotionPreference);
        this.applyBackdrop(this.index);
        this.start();
      }

      applyBackdrop(index) {
        const tone = this.slides[index]?.dataset.backdrop;
        if (tone) this.style.setProperty('--tpx-backdrop', tone);
      }

      show(next) {
        this.index = next;
        this.applyBackdrop(next);
        this.slides.forEach((slide, index) => {
          const active = index === next;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.tabIndex = active ? 0 : -1;
          if (active && this.cta && slide.href) this.cta.href = slide.href;
        });
        this.dots.forEach((dot, index) => {
          const active = index === next;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-pressed', String(active));
        });
        this.names.forEach((name, index) => name.classList.toggle('is-active', index === next));
      }

      start() {
        if (this.slides.length < 2 || this.reduceMotion.matches || this.timer || document.hidden) return;
        this.timer = window.setInterval(() => this.show((this.index + 1) % this.slides.length), Number(this.dataset.interval) || 6500);
      }

      stop() {
        window.clearInterval(this.timer);
        this.timer = null;
      }

      restart() {
        this.stop();
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this.handleVisibility);
        this.reduceMotion?.removeEventListener('change', this.handleMotionPreference);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
